module.exports = __webpack_public_path__ + "img/account-directive.8447193a.png";